import { inject, Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { CognitoCookieService, UsersService } from '@callrail/looky/core';
import { LocationService } from '@callrail/looky/util';
import { RedirectService } from '../redirect/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class PostLoginService {
  private readonly locationService = inject(LocationService);
  private readonly cognitoCookieService = inject(CognitoCookieService);
  private readonly redirectService = inject(RedirectService);
  private readonly usersService = inject(UsersService);

  public redirect(queryParams: ParamMap): void {
    this.cognitoCookieService.resetUserSignedOut();
    this.redirectService.redirect(queryParams).subscribe({
      next: ({ redirect_to }) => {
        this.usersService.updateLastSignIn().subscribe();
        this.locationService.go(redirect_to, true);
      },
      error: () => {
        this.locationService.go('/authenticate/sign_out', true);
      },
    });
  }
}
